import React from 'react';
import CheckboxTree from 'react-checkbox-tree';
import './SchemeCheckboxTree.scss';

class SchemeCheckboxTree extends React.Component {
  state = {
    expanded: [],
    checked: [],
  };

  componentWillMount() {
    const { input } = this.props;
    const checked =
      input.value && Array.isArray(input.value)
        ? input.value.map((input) => input.id)
        : [];
    this.setState({ checked });
  }

  handleCheckedChange(checked) {
    const { handleSchemesChanged } = this.props;
    this.setState({ checked });
    handleSchemesChanged(checked);
  }

  render() {
    const { nodes, meta } = this.props;

    return (
      <div>
        <CheckboxTree
          nodes={nodes}
          checked={this.state.checked}
          expanded={this.state.expanded}
          showNodeIcon={false}
          onCheck={(checked) => this.handleCheckedChange(checked)}
          onExpand={(expanded) => this.setState({ expanded })}
          icons={{
            check: <span className="fas fa-check-square" />,
            uncheck: <span className="far fa-square" />,
            halfCheck: <span className="fas fa-check-square" />,
            expandClose: <span className="fas  fa-chevron-right" />,
            expandOpen: <span className="fas  fa-chevron-down" />,
            expandAll: <span className="fas  fa-plus-square" />,
            collapseAll: <span className="fas  fa-minus-square" />,
            parentClose: <span className="fas  fa-folder" />,
            parentOpen: <span className="fas  fa-folder-open" />,
            leaf: <span className="fas  fs-file" />,
          }}
        />
        {meta && meta.touched && meta.error && (
          <span className="input-error">{meta.error}</span>
        )}
      </div>
    );
  }
}
export default SchemeCheckboxTree;
